export default __webpack_public_path__ + "static/6809-5bbac12420bceed1450e481387c0b238.jpg";